import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'

import Button from '../Button'
import ProgressBar from '../ProgressBar'
import { formatBytes, renderIcon } from '../utils/helpers'
import { useToggle } from '../utils/hooks'

const FileListItem = ({
  file,
  uploadFunction,
  deleteFunction,
  setDroppedFiles
}) => {
  const [fileListItem, toggleFileListItem] = useToggle(true)
  const [requestSent, setRequestSent] = useToggle(false)
  const [progress, setProgress] = useState(0)
  const [fileUUID, setFileUUID] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  // const validDeleteFunction = typeof deleteFunction === 'function';
  const validDeleteFunction = true // ! Update when function exists

  useEffect(() => {
    if (!requestSent) {
      const uploadRequest = async() => {
        await uploadFunction({ file, setProgress, setErrorMessage, setFileUUID })
      }
      uploadRequest()
      setRequestSent(true)
    }
  }, [file, requestSent, setRequestSent, uploadFunction])

  // Delete item from DB
  const deleteItem = (status) => {
    if (status) {
      toast.warning('File Deleted (Mock Request)')
      setDroppedFiles((files) => files.filter((d) => d.uniqueId !== file.uniqueId))
      toggleFileListItem()
      const deleteRequest = async() => {
        validDeleteFunction && await deleteFunction(fileUUID)
      }
      deleteRequest()
    } else {
      setErrorMessage('')
      const uploadRequest = async() => {
        await uploadFunction({ file, setProgress, setErrorMessage, setFileUUID })
      }
      uploadRequest()
    }
  }

  return (
    fileListItem &&
    <div className='d-flex alert bg-light' role='Uploaded File' style={{
      border: '2px solid #ECECEC',
      borderRadius: '3px'
    }}>
      <div className='w-100'>
        <div className="row px-2 py-1">
          {/* File information */}
          <div className="col-7 my-auto d-flex p-0">
            <div className='d-flex ms-2 bg-primary d-none d-sm-block'>
              <span className={`h-100 d-flex align-items-center fas ${renderIcon(file.type)} fs-2 mx-2 px-1`} aria-hidden='true' />
            </div>
            <div className='text-truncate ms-3'>
              <p className='text-truncate text-dark mb-1'>{file.name}</p>
              <p className='fs-7 text-muted mb-1'>{formatBytes(file.size)}</p>
            </div>
          </div>

          {/* File Upload Progress */}
          <div className="col-5 my-auto">
            {progress !== 100 ? (
              <ProgressBar
                variant={errorMessage ? 'danger' : 'success'}
                progress={progress}
                size='sm'
                animated={progress !== 100}
                label={progress !== 0}
                className={progress === 100 ? 'transition-progress-bar' : ''}
              />
            ) : null}

            {/* File Failed to Upload. Can remove item */}
            {errorMessage && (
              <p className='h-100 justify-content-end d-flex align-items-center text-danger mt-1 mb-0 fw-bold'>
                <small className='text-center'>FAILURE, TRY AGAIN</small>
                <Button
                  ghost
                  variant='primary'
                  size='sm'
                  ariaLabel='Close'
                  onClick={() => {
                    if (validDeleteFunction) {
                      deleteItem(false)
                    }
                  }}
                  className='ms-5 me-2 p-2'
                >
                  <span className='text-muted fas fa-rotate-right fs-5' aria-hidden='true' />
                </Button>
              </p>
            )}

            {/* File Uploaded Successfully. Can remove and delete item */}
            {progress === 100 && !errorMessage && fileUUID && (
              <p className='h-100 justify-content-end d-flex align-items-center text-success mt-1 mb-0 fw-bold'>
                <small className='text-center'>100% Complete</small>
                <Button
                  ghost
                  variant='primary'
                  size='sm'
                  ariaLabel='Close'
                  onClick={() => {
                    if (validDeleteFunction) {
                      deleteItem(true)
                    }
                  }}
                  className='ms-5 p-2'
                >
                  <span className='text-muted fas fa-trash fs-5' aria-hidden='true' />
                </Button>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

FileListItem.propTypes = {
  file: PropTypes.object,
  uploadFunction: PropTypes.func,
  deleteFunction: PropTypes.func,
  upload: PropTypes.bool,
  setDroppedFiles: PropTypes.func
}

export default FileListItem
